import { TagPreference } from '@hungryroot/page-food-profile';
import { type TagGroupDetail } from '@hungryroot/rest';
import { type CustomerTagGroupResponse } from '@hungryroot/tags';
import { type DislikeTagPreference } from '../components/ControlTagSwitch/ControlTagSwitch';

/**
 * Returns comma-separated string of selected tags from the customer's selected
 * preferences compared against tags from the BE.
 */
export function getCustomerTags(
  customerTags: Pick<CustomerTagGroupResponse, 'results'> | undefined,
  queryTags: Pick<TagGroupDetail, 'id' | 'name'>[] | undefined,
  selectedTagPreference:
    | TagPreference.Selected
    | DislikeTagPreference.Selected = TagPreference.Selected
) {
  if (!(customerTags && queryTags)) {
    return;
  }

  // Get tags that customers selected after cross-comparing to allowed tags from BE
  const selectedTagDetails = customerTags.results
    .filter((pref) => pref.preference === selectedTagPreference)
    .map((pref) => queryTags?.find((tag) => tag.id === pref.tag));

  // Return as a comma-separated string
  const tagNames = selectedTagDetails
    ?.map((pref) => pref?.name)
    .filter((name) => !!name);
  return tagNames?.join(', ');
}
